module.exports = __webpack_public_path__ + "img/Jspades.fbd563e1.jpg";